import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ExtraInningRulesStore } from 'stores/Tagging/ExtraInningRulesStore';
import Switch from 'react-switch';
import { Description } from 'pages/ScheduledGames/GameDialog/components/Preferences/styles/PreferencesStyles';
import { LineupStore } from 'stores/LineupStore';
import { InningRulesWrapper, Title } from './styles/ExtraInningRulesSwitch';

const ExtraInningRuleSwitch = observer(() => {
  const extraInningRuleStore = useInjection<ExtraInningRulesStore>(ServiceTypes.ExtraInningRulesStore);
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);

  const changeHandler = (checked: boolean): void => {
    extraInningRuleStore.setIsExtraRunnerEnabled(checked);
  };

  useEffect(() => {
    const gameLevels = ['MLB', 'AAA', 'AA', 'HighA', 'LowA'];
    if (lineupStore.gameLevel && lineupStore.gameLevel.name && gameLevels.includes(lineupStore.gameLevel.name)) {
      extraInningRuleStore.setIsExtraRunnerEnabled(true);
    } else {
      extraInningRuleStore.setIsExtraRunnerEnabled(false);
    }
  }, [lineupStore.gameLevel]);

  return (
    <InningRulesWrapper data-testid='extra-inning-switch-wrapper'>
      <div>
        <Title>Extra innings rules</Title>
        <Description />
      </div>
      <Switch
        checked={extraInningRuleStore.isExtraRunnerEnabled}
        onColor='#ec691a'
        checkedIcon={false}
        uncheckedIcon={false}
        width={51}
        height={31}
        onChange={changeHandler}
      />
    </InningRulesWrapper>
  );
});

export default ExtraInningRuleSwitch;
